<template>
 <div class="grid-x flex-grow service-category-about">
    <div class="cell auto cell-block-y flex flex-col flex-grow">
      <div class="flex flex-col flex-grow">
        <div class="flex-grow flex justify-between py-8 px-8 service-category-about-columns">
          <div class="flex flex-col mr-16 max-w-3-5 w-full">
            <b class="text-sm text-inverse-darken mb-6">Описание:</b>
            <template v-if="!edit">
              <span class="text-brown whitespace-pre-line text-sm">
                {{ category.description }}</span>
              <div class="flex justify-start mt-6">
                <ButtonBorderless theme="blue"
                @click.native="onEditDescription">Редактировать описание</ButtonBorderless>
              </div>
            </template>
            <template v-else>
              <Input
                :textarea="true"
                classes="border-muted-light max-w-full"
                v-model="category.description"/>
              <div class="flex justify-end items-center w-full mt-4">
                <ButtonBorderless class="mr-8"
                @click.native="cancelEdit">Отменить</ButtonBorderless>
                <ButtonBorderless theme="green"
                @click.native="onDescriptionSave">Сохранить</ButtonBorderless>
              </div>
            </template>
          </div>
          <div class="flex flex-col max-w-2-5 w-full">
            <div class="flex flex-col mb-8">
              <span class="flex text-sm text-muted mb-3">Иконка категории для старой формы:</span>
              <Select
                :icons="true"
                v-if="attach && attach.length"
                :options="attach"
                class="bg-hint w-72"
                :label="'name'"
                :value="category.iconAttach"
                @input="onIconChange"
                placeholder="Выберите текущую иконку категории"/>
              <span class="text-12px text-gray-600 mt-3">
                Существующая иконка сохраняется для legacy web-формы.
              </span>
            </div>
            <V2AttachmentUpload
              mode="icon"
              :value="category.v2IconAttach"
              @input="onV2IconChange"
              title="Иконка категории для новой формы"
              hint="Иконка для новой формы и мобильного приложения. Если не задана, используется старая. Рекомендуемый размер — 512×512."
            />
            <div class="mt-8 flex flex-col space-y-2">
              <Check
                :value="Boolean(category.onePerOrder)"
                @input="onOnePerOrderChange"
                label="Не более одной основной услуги этой категории"
              />
              <span class="text-12px text-gray-600">
                Включено — пользователь выбирает не более одной основной услуги (например, один вид уборки).
                Обязательные услуги добавляются автоматически и не занимают этот лимит.
                Выключено — можно выбрать несколько основных услуг (например, благоустройство).
              </span>
            </div>
          </div>
        </div>
        <div class="p-8 font-bold border-t border-b border-solid border-light">
          <span>Как это работает:</span>
        </div>
        <div class="flex flex-col">
          <CategoryOffer v-for="(offer, index) in offers"
          @offer-save="onOfferSave"
          @offer-cancel="onOfferCancel"
          :isEditDisabled="true"
          :key="offer.id"
          :index="index"
          :offer="offer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import ButtonBorderless from '@/components/ButtonBorderless.vue';
import Input from '@/components/Input.vue';
import Select from '@/components/Select.vue';
import CategoryOffer from '@/components/Services/CategoryOffer.vue';
import Check from '@/components/Check.vue';
import V2AttachmentUpload from '@/components/Services/V2AttachmentUpload.vue';

export default {
  components: {
    ButtonBorderless,
    CategoryOffer,
    Input,
    Select,
    Check,
    V2AttachmentUpload,
  },
  data() {
    return {
      edit: false,
    };
  },
  computed: {
    ...mapState({
      categories: (state) => state.services.categories,
      attach: (state) => state.services.attach,
    }),
    category: {
      get() {
        if (this.categories && this.categories.length) {
          return this.categories.find((el) => el.id === this.$route.params.id);
        }
        return {};
      },
      set(newVal) {
        let category = this.categories.find((el) => el.id === this.$route.params.id);
        category = newVal;
        return category;
      },
    },
    offers: {
      get() {
        if (!_.isEmpty(this.category)) {
          return this.category.offers;
        }
        return [];
      },
      set(newValue) {
        this.category.offers = newValue;
      },
    },
  },
  watch: {
    'category.iconAttach': {
      handler(value) {
        this.$emit('input', value);
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(
      'services',
      [
        'ACT_FETCH_SERVICE_CATEGORIES_ATTACH',
        'ACT_UPDATE_SERVICE_CATEGORY',
      ],
    ),
    async getServiceCategoriesAttach() {
      await this.ACT_FETCH_SERVICE_CATEGORIES_ATTACH();
    },
    async updateServiceCategory({ id, ...payload }) {
      await this.ACT_UPDATE_SERVICE_CATEGORY({
        id,
        ...payload,
      }).then(() => {
        this.edit = false;
      }).catch((error) => {
        console.log(error);
      });
    },
    async onOnePerOrderChange(value) {
      await this.updateServiceCategory({
        id: this.category.id,
        ...this.category,
        onePerOrder: Boolean(value),
      });
      this.category.onePerOrder = Boolean(value);
      this.$iwalyNotify.success({
        text: 'Режим выбора услуг обновлён!',
      });
    },
    async onIconChange(e) {
      await this.updateServiceCategory({
        id: this.category.id,
        ...this.category,
        iconAttach: e,
      }).then(() => {
        this.$iwalyNotify.success({
          text: 'Изображение категории успешно изменено!',
        });
      }).catch((error) => {
        console.log(error);
      });
    },
    async onV2IconChange(e) {
      await this.updateServiceCategory({
        id: this.category.id,
        ...this.category,
        v2IconAttach: e,
      }).then(() => {
        this.$iwalyNotify.success({
          text: e ? 'Иконка новой формы обновлена!' : 'Иконка новой формы убрана. Используется fallback.',
        });
      }).catch((error) => {
        console.log(error);
      });
    },
    cancelEdit() {
      this.edit = false;
    },
    onOfferCancel(e, isEditing, beforeEditingOffer) {
      this.offers = this.offers.map((el) => {
        let result = {};
        if (el.id === beforeEditingOffer.id) {
          result = {
            ...beforeEditingOffer,
          };
          return result;
        }
        return el;
      });
    },
    onEditDescription() {
      this.edit = true;
    },
    onOfferSave() {
      this.updateServiceCategory({
        id: this.category.id,
        ...this.category,
      });
    },
    onDescriptionSave() {
      this.updateServiceCategory({
        id: this.category.id,
        ...this.category,
      });
    },
  },
  mounted() {
    this.getServiceCategoriesAttach();
  },
};
</script>
